import googleTagManager from '@analytics/google-tag-manager';
import { originalSourcePlugin } from '@analytics/original-source-plugin';
import { logger } from 'lib/hatchd-utils';
import Analytics from 'analytics';

export const GTM_ID = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;

export enum EventName {
  signin = 'signin',
  signout = 'signout',
  createPriceGrid = 'createPriceGrid',
  sendOffer = 'sendOffer',
  sendCounterOffer = 'sendCounterOffer',
  acceptOffer = 'acceptOffer',
}

// dev only plugins
const devOnlyPlugins = [
  {
    name: 'logger',
    page: ({ payload }: any) => {
      logger.log('page', payload);
    },
    track: ({ payload }: any) => {
      logger.log('track', payload);
    },
    identify: ({ payload }: any) => {
      logger.log('identify', payload);
    },
  },
];

// prod only plugins
const gtmPlugins = [
  googleTagManager({
    containerId: GTM_ID,
  }),
];

const analytics = Analytics({
  app: 'agora-livestock',
  plugins: [
    originalSourcePlugin(),
    ...(!GTM_ID ? devOnlyPlugins : []),
    ...(GTM_ID ? gtmPlugins : []),
  ],
});

// tracking page views
export const pageView = (url: string) => {
  analytics.page({ url: url });
};

// tracking basic or custom events
export const trackEvent = (
  event: EventName,
  payload?: { [key: string]: any }
) => {
  analytics.track(event, payload);
};

// tracking logged in user
export const trackUser = (userId: string, payload?: { [key: string]: any }) => {
  analytics.identify(userId, payload);
};
